import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/constant';
import { ApiResponse } from '@/types';

/**
 * 分拣传站规则配置类型
 */
export const SORTING_TRANSFER_RULE_CONFIG_TYPE = 'DISTRIBUTE_TRANSFER_CONF';

/**
 * 规则配置模板字段（ruleConfigPattern JSON 字符串解析后的单项）
 */
export interface RuleConfigPatternField {
  /** 字段 key（ruleConfigValue 中的属性名） */
  field: string;
  /** 字段展示名称 */
  name: string;
  /** 字段类型（如 Integer） */
  type: string;
  /** 字段说明 */
  description: string;
  /** 是否必填 */
  required: boolean;
  /** 子字段（预留） */
  child: unknown[];
}

/**
 * 规则配置值（ruleConfigValue JSON 字符串解析后的结构，由模板动态定义）
 */
export type RuleConfigValue = Record<string, any>;

/**
 * 查询规则配置入参
 */
export interface GetRuleConfigRequest {
  /** 配置类型 */
  ruleConfigType: string;
}

/**
 * 规则配置项
 */
export interface RuleConfigItem {
  /** 规则配置类型 */
  ruleConfigType: string;
  /** 规则配置值（JSON 字符串） */
  ruleConfigValue: string;
  /** 规则配置模板 */
  ruleConfigPattern: string;
  /** 创建时间 */
  createTime: string;
  /** 更新时间 */
  modifyTime: string;
  /** 更新用户 */
  modifyUser: string;
}

/**
 * 更新规则配置入参
 */
export interface UpdateRuleConfigRequest {
  /** 规则配置类型 */
  ruleConfigType: string;
  /** 规则配置值（JSON 字符串） */
  ruleConfigValue: string;
}

/**
 * 规则配置相关接口
 */
class RuleConfigApi {
  /**
   * 查询配置列表
   */
  public async getRuleConfigByType(
    params: GetRuleConfigRequest
  ): Promise<ApiResponse<RuleConfigItem>> {
    return request({
      path: '/k2/management/rule/config/getRuleConfigByType',
      method: Method.POST,
      body: params,
    });
  }

  /**
   * 更新配置值
   */
  public async updateRuleConfigByType(
    params: UpdateRuleConfigRequest
  ): Promise<ApiResponse<null>> {
    return request({
      path: '/k2/management/rule/config/updateRuleConfigByType',
      method: Method.POST,
      body: params,
    });
  }
}

export const ruleConfigApi = new RuleConfigApi();
export default ruleConfigApi;
